/* @flow */
import React from 'react';

import Navigation from 'components/UIKit/Details/Navigation';
import NavItem from 'components/UIKit/Details/Navigation/NavItem';
import Count from 'components/UIKit/Details/Navigation/Count';
import TreeIcon from 'components/icons/TreeIcon';
import AnnotationIcon from 'components/icons/AnnotationIcon';
import TransactionIcon from 'components/icons/TransactionIcon';
import ReadGroupIcon from 'components/icons/ReadGroupIcon';
import BiospecimenIcon from 'components/icons/BiospecimenIcon';
import DetailsIcon from 'components/icons/DetailsIcon';
import DownloadIcon from 'components/icons/DownloadIcon';

export default function BiospecimenDetailsNavigation({
  details, active, handleOnClick
}: any): React.Element {
  let item = (details || {}).item;
  let annotationsCount = ((item || {}).annotations || []).length;
  let transactionsCount = ((item || {})._transaction_logs || []).length;

  let type = <BiospecimenIcon />;

  return (
    <Navigation details={details} type={type} active={active} handleOnClick={handleOnClick}>
      <NavItem spyId="actions" tooltip={{text: 'Actions'}}>
        <DownloadIcon />
      </NavItem>
      <NavItem spyId="details" tooltip={{text: 'Information'}}>
        <DetailsIcon />
      </NavItem>
      <NavItem spyId="hierarchy" tooltip={{text: 'Hierarchy'}}>
        <TreeIcon />
      </NavItem>
      {item.type === 'aliquot' && <NavItem spyId="data" tooltip={{text: 'Files'}}>
        <ReadGroupIcon style={{color: '#888'}}/>
      </NavItem>}
      <NavItem spyId="annotations" tooltip={{text: 'Annotations'}}>
        <AnnotationIcon />
        <Count>{annotationsCount}</Count>
      </NavItem>
      <NavItem spyId="transactions" tooltip={{text: 'Transactions'}}>
        <TransactionIcon />
        <Count>{transactionsCount}</Count>
      </NavItem>
    </Navigation>
  );
}
